const List = ({ children, gridCols }) => {
  return (
    <div
      className={`border-2 mt-8 mx-12 grid auto-rows-min bg-light-border-gray ${gridCols} gap-x-0.5 gap-y-0.5 border-2`}
    >
      {children}
    </div>
  );
};

export default List;
